import { render, staticRenderFns } from "./riskSafetyInfo.vue?vue&type=template&id=d9d81fa0"
import script from "./riskSafetyInfo.vue?vue&type=script&lang=js"
export * from "./riskSafetyInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9d81fa0')) {
      api.createRecord('d9d81fa0', component.options)
    } else {
      api.reload('d9d81fa0', component.options)
    }
    module.hot.accept("./riskSafetyInfo.vue?vue&type=template&id=d9d81fa0", function () {
      api.rerender('d9d81fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/plan/riskSafetyInfo.vue"
export default component.exports